module.exports = __webpack_public_path__ + "static/img/pic_xbzjx@2x.615a024d.png";